import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SortAlpAscIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SortAlpAsc",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M13.19 23.74h-2.45V2.88c0-.48-.39-.88-.88-.88H8.11c-.48 0-.88.39-.88.88v20.87h-2.4c-1.15 0-1.43.67-.61 1.48l4.76 4.78 4.79-4.79c.83-.81.56-1.47-.59-1.47Zm3.95 4.29 6.66-8.37h-6.55v-1.91h9.15v1.97l-6.69 8.34h6.79V30h-9.35v-1.97ZM21.09 2H23l5.25 12.25h-2.49l-1.14-2.8h-5.31l-1.11 2.8h-2.44zm2.78 7.6-1.9-4.97-1.93 4.97h3.82Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M7.57 27.89c-.63 0-1.14-.51-1.14-1.14V6.17a1.14 1.14 0 1 1 2.28 0v20.57c0 .63-.51 1.14-1.14 1.14Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M7.57 27.89c-.3 0-.59-.12-.81-.33l-4.57-4.57a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l3.76 3.76 3.76-3.76a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62l-4.57 4.57c-.21.21-.5.33-.81.33M22.17 5h2.67l3.31 8.94h-2.4l-.51-1.51h-3.46l-.51 1.51h-2.4L22.18 5Zm2.42 5.54L23.51 7.3l-1.1 3.24zM19.82 26.28l3.88-5.27h-3.65v-2.06h6.79v1.59l-3.92 5.28h4.06v2.06h-7.16v-1.61Z"
      })]
    })
  }));
};
SortAlpAscIcon.displayName = 'SortAlpAscIcon';